const insuranceNameMap: Record<string, string> = {
  Sjukdom: "ags - sjukskrivning",
  Arbetssjukdom: "tfaa - arbetssjukdom",
  Arbetsskada: "tfao - olycksfall",
  Dödsfall: "tgl - dödsfall",
  Föräldraledighet: "fpt - föräldraledighet",
  "Uppsägning vid arbetsbrist": "agb - arbetsbrist",
};

/**
 * Maps a display-facing insurance name (e.g. "Sjukdom") to the analytics
 * value expected by GA4 (e.g. "ags - sjukskrivning").
 *
 * Returns `undefined` when the input is falsy, and passes through unknown
 * values unchanged so new options don't silently disappear from tracking.
 */
export const mapInsuranceName = (name?: string): string | undefined => {
  if (!name) return undefined;
  return insuranceNameMap[name] ?? name;
};
